exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.type-label[data-v-72b05ade] {\n\tcolor: var(--wf-primary);\ndisplay:block;\nfont-weight: 400;\nfont-size: 1em;\ntext-transform:uppercase;\n}\nh1[data-v-72b05ade] {\n\tfont-size:22px;\n}\n.group-title-wrapper[data-v-72b05ade] {\n\twidth:100%;\n}\nh1.edit-d-title[data-v-72b05ade]::after {\n\tbackground:transparent;\n\tright:-40px;\n}\ntextarea.title-field[data-v-72b05ade] {\n\tfont-size:22px;\n}\n", ""]);

// exports
